import styled from 'styled-components';

export const TopSectionMainWrap = styled.section(
  props => `
        width:100%;
        display: flex;
        background-image: linear-gradient(248deg, #432346 100%, rgba(30, 36, 95, 0.88) 1%);
        height: 65.5rem;
        border-radius: 0 0 50% 50%/60px;

        @media(max-width:1023px){
            height: 96rem;
        }
    `,
);

export const TopSectionInnerWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        max-width:1350px;
        margin:0 auto;
        flex-direction: column;
        padding-top: 4rem;
        padding-bottom: 8rem;
        @media(max-width:1023px){
            padding-top: 0;
        }
        @media only screen and (min-width:1024px) and (max-width:1390px){
            padding: 2rem 2rem;
        }
    `,
);
